export class SchemaColumn
{
    public readonly name:string;
    public readonly type:any;
    public readonly unique:boolean;
    public readonly notNull:boolean;

    constructor(json:any)
    {
        this.name = json['name'];
        this.type = json['type'];
        this.unique = json['unique'];
        this.notNull = json['notNull'];
    }
}
